import {
  SET_STORE_TEMP_STORE_CUSTOMER_NAME,
  SET_STORE_TEMP_FUN_STORE_CSID,
} from "../../database/store-data";
import {
  Temp_Get_CustomerPhoneNO,
  GET_SET_STORED_DATA,
} from "../../database/get-stored-data";
import { PT_OTP, PT_PROFILE } from "../../routes/stack/paths/pt-profile";
import { api_SaveCustomer } from "../../connection/api/api-profile";
import { dto_Customer } from "../../classes/dto-customer";
import { ToastMessage } from "../../components/toast-notification/toast";
import { Colors } from "../../util/colors";
import { Font } from "../../util/config-fonts";
import React from "react";
import "../../styles/css/pg-profile-register.css";

export default class REGISTER extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isActive: false,
      value: "",
      phoneno: "",
      isActivePhoneNo: false,
    };
    this.handleTextChangeName = this.handleTextChangeName.bind(this);
    this.handleTextChangePhoneNo = this.handleTextChangePhoneNo.bind(this);
  }
  handleTextChangeName(text) {
    this.setState({ value: text });
    if (text !== "") {
      this.setState({ isActive: true });
    } else {
      this.setState({ isActive: false });
    }
  }

  handleTextChangePhoneNo(text) {
    this.setState({ phoneno: text });
    if (text !== "") {
      this.setState({ isActivePhoneNo: true });
    } else {
      this.setState({ isActivePhoneNo: false });
    }
  }

  async componentDidMount() {
    await GET_SET_STORED_DATA();
    this.setState({
      phoneno: await Temp_Get_CustomerPhoneNO(),
      isActivePhoneNo: true,
    });
  }

  render() {
    const { value, isActive, isActivePhoneNo } = this.state;

    return (
      <div className="pgProfileRegisterLayout">
        <p style={{ fontFamily: "Medium", textAlign: "center" }}> REGISTER </p>
        <div
          style={{
            alignItems: "center",
            position: "fixed",
            top: 60,
            cursor: "pointer",
          }}
          onClick={() => {
            this.props.navigate(PT_PROFILE);
          }}
        >
          <i className="fa fa-arrow-left" aria-hidden="true"></i>
        </div>
        <div className="float-label" style={{ marginBottom: 8 }}>
          <input
            id="fullname"
            type="text"
            value={value}
            onChange={(e) => this.handleTextChangeName(e.target.value)}
            style={{ borderBottom: "1px solid ddd" }}
          />
          <label className={isActive ? "Active" : ""}>Name</label>
        </div>

        <div className="float-label" style={{ marginBottom: 8 }}>
          <input
            type="text"
            value={this.state.phoneno}
            //value="Hello"
            onChange={(e) => this.handleTextChangePhoneNo(e.target.phoneno)}
            readOnly
          />

          <label className={isActivePhoneNo ? "ActivePhoneNo" : ""}>
            Mobile Number
          </label>
        </div>

        <div style={{ marginTop: 40 }}>
          {this.state.isLoading ? (
            <button
              id="button"
              style={{
                fontSize: Font.Heading,
                color: "#fff",
                background: Colors.ThemeBGcolor,
                width: "40%",
                height: 48,
                border: "none",
                fontFamily: "Medium",
                float: "right",
              }}
            >
              <i
                className="fa fa-circle-o-notch fa-spin"
                aria-hidden="true"
              ></i>
            </button>
          ) : (
            <button
              id="button"
              style={{
                fontSize: Font.Heading,
                color: "#fff",
                background: Colors.ThemeBGcolor,
                width: "40%",
                height: 48,
                border: "none",
                fontFamily: "Medium",
                float: "right",
                borderRadius: "4px",
              }}
              onClick={() => {
                this.ResgisterCustomer();
              }}
            >
              SUBMIT
            </button>
          )}
        </div>
      </div>
    );
  }

  async ResgisterCustomer() {
    var Phone = this.state.phoneno;
    var FullName = document.getElementById("fullname").value;

    if (Phone === "") {
      // Alert.MessageBox({
      //   Icon: "info",
      //   ConfirmButtonText: "ok",
      //   Text: "Please Enter Your Phone Number",
      //   Tittle: "Phone Number Field Empty",
      // });

      await ToastMessage(
        3,
        "Please Enter Your Phone Number, Phone Number Field Empty",
      );

      return;
    }
    if (FullName === "") {
      // Alert.MessageBox({
      //   Icon: "info",
      //   ConfirmButtonText: "ok",
      //   Text: "Please Enter Your Name",
      //   Tittle: "Name Field Empty",
      // });

      await ToastMessage(3, "Please Enter Your Name, Name Field Empty");

      return;
    }
    this.setState({ isLoading: true });
    let data = await api_SaveCustomer(FullName, Phone, "", "", "", 0);
    let objData = JSON.parse(data);
    if (objData.Result !== "0") {
      let AppendData = JSON.parse(objData.Result);

      dto_Customer.CSID = AppendData[0][0].CSID;
      dto_Customer.CusName = AppendData[0][0].CusName;

      dto_Customer.PhoneNo = AppendData[0][0].PhoneNo;
      SET_STORE_TEMP_FUN_STORE_CSID(AppendData[0][0].CSID);
      SET_STORE_TEMP_STORE_CUSTOMER_NAME(AppendData[0][0].CusName);

      this.setState({ isLoading: false });
      this.props.navigate(PT_OTP);
    }
  }
}
